import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-document-capture-warning-dialog",
  templateUrl: "./document-capture-warning-dialog.component.html",
  styleUrls: ["./document-capture-warning-dialog.component.css"],
})
export class DocumentCaptureWarningDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<DocumentCaptureWarningDialogComponent>
  ) {}
  headingId: string = '';

  ngAfterViewInit(): void {
    const ele: any = document.querySelector('mat-dialog-container');
    //settimeout used because aria-labelledby is getting render after sometimes
    setTimeout(() => {
      const dynamicElementTitle: any = ele.getAttribute('aria-labelledby');
      if(ele && dynamicElementTitle) {
        this.headingId = dynamicElementTitle;
      }
    }, 0);
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
